import React from "react";

import Select from "react-select";
const MultiSelect = ({ option = [], onChange, value }) => {
  return (
    <div>
      <Select
        // defaultValue={[colourOptions[2], colourOptions[3]]}
        value={value}
        isMulti
        name="colors"
        options={option}
        className="basic-multi-select"
        classNamePrefix="select"
        onChange={onChange}
      />
    </div>
  );
};

export default MultiSelect;
